module.exports = __webpack_public_path__ + "static/media/Privacy-1.0ee32ebc.png";